export const MAX_COLUMNS_COUNT = 10;
